import React, { Component } from "react";

class Loader extends Component {
    render() {
        return (
            <div className="app-loader" style={{ zIndex: '1111' }}>
                <p className="loader">loading..</p>
            </div>
        );
    }
}

export default Loader;
